import React, { useContext } from "react";
import { ThemeContext } from "../../theme/ThemeContext";

function ExportIconHover() {
  const { darkMode } = useContext(ThemeContext);
  return (
    
<svg xmlns="http://www.w3.org/2000/svg" width="19.998" height="20.008" viewBox="0 0 19.998 20.008">
  <path id="Union_556" data-name="Union 556" d="M13722.888-18791.551a5.566,5.566,0,0,1,5.56-5.559,5.564,5.564,0,0,1,5.551,5.559,5.561,5.561,0,0,1-5.551,5.557A5.563,5.563,0,0,1,13722.888-18791.551Zm4.89,2.668a.672.672,0,0,0,.67.666.671.671,0,0,0,.665-.666v-3.725l.859.859a.663.663,0,0,0,.472.2.664.664,0,0,0,.473-.2.665.665,0,0,0,0-.939l-2-2a.649.649,0,0,0-.473-.2.662.662,0,0,0-.472.2l-2,2a.664.664,0,0,0,0,.939.651.651,0,0,0,.472.2.668.668,0,0,0,.472-.2l.859-.859Zm-4.46,2.883h0Zm-6.315,0a3,3,0,0,1-3-3v-14a3.007,3.007,0,0,1,3-3h5.584a2.061,2.061,0,0,1,1.415.586l5.414,5.418a2,2,0,0,1,.547,1.043,7.429,7.429,0,0,0-1.52-.156,7.554,7.554,0,0,0-5.238,2.109H13719a1,1,0,0,0-1,1.006,1,1,0,0,0,1,1h2.719a7.551,7.551,0,0,0-.693,2.006H13719a1,1,0,0,0-1,1,1,1,0,0,0,1,1h1.907a7.542,7.542,0,0,0,2.412,5Z" transform="translate(-13714 18806.002)" fill={darkMode ? '#fff' : '#474a4e'}/>
</svg>
  );
}

export default ExportIconHover;
